import React from 'react';
import { filter } from 'lodash';

const getTestimonialData = state => {
  if (!state.TestimonialReducer.testimonials) {
    return null;
  }
  if (state.TestimonialReducer.testimonials.type === 'Vertical') {
    return formatTestimonialData(state.TestimonialReducer.testimonials);
  } else return formatCareerData(state.TestimonialReducer.testimonials);
};

const getTestimonialLoading = state => {
  return state.TestimonialReducer.loading.testimonials;
};

const getTestimonialError = state => {
  return state.TestimonialReducer.error.testimonials;
};
const isLoading = state => {
  return getTestimonialLoading(state);
};

const formatTestimonialData = data => {
  let testimonials = [];

  const media_path = (data && data.data && data.data.media_path) || '';
  const web =
    (data && data.data && data.data.device && data.data.device.web) || '';
  const mobile =
    (data && data.data && data.data.device && data.data.device.mobile) || '';
  const thumbnail =
    (data && data.data && data.data.device && data.data.device.thumbnail) || '';

  let pageData = filter(
    data && data.data && data.data.testimonials,
    ({ vertical_id }) => vertical_id === data.vertical_id
  );
  pageData.map(testimonial => {
    const result = {
      web: web,
      mobile: mobile,
      media_path: media_path,
      thumbnail: thumbnail,
      title: testimonial.title,
      description: testimonial.description,
      mobile_description: testimonial.mobile_description,
      testimonial_clients: testimonial.testimonial_clients,
      url_video: testimonial.video,
    };
    testimonials.push(result);
  });
  return testimonials;
};

const formatCareerData = data => {
  let testimonials = [];

  const media_path = data && data.data && data.data.media_path;
  const web = data && data.data && data.data.device && data.data.device.web;
  const mobile =
    data && data.data && data.data.device && data.data.device.mobile;
  const thumbnail =
    data && data.data && data.data.device && data.data.device.thumbnail;
  let pageData = filter(
    data && data.data && data.data.testimonials,
    ({ type }) => type === data.type
  );

  pageData.map(testimonial => {
    const result = {
      web: web,
      mobile: mobile,
      media_path: media_path,
      thumbnail: thumbnail,
      title: testimonial.title,
      isMemberRoleVisible: true,
      description: testimonial.description,
      mobile_description: testimonial.mobile_description,
      testimonial_clients: testimonial.testimonial_clients,
    };
    testimonials.push(result);
  });
  return testimonials;
};
export const TestimonialSelector = {
  getTestimonialData,
  getTestimonialLoading,
  getTestimonialError,
  isLoading,
};
